import { CreateOrEditPriceListFormValues } from "../../priceListTypes"

type FieldKey = keyof CreateOrEditPriceListFormValues

export enum TabsOrder {
    GENERAL,
    CUSTOMER,
    // PRODUCTS,
    POS,
}

export const fieldTabMap: { [field in FieldKey]: TabsOrder } = {
    name: TabsOrder.GENERAL,
    shops: TabsOrder.GENERAL,
    isActive: TabsOrder.GENERAL,
    messageToCustomers: TabsOrder.GENERAL,
    internalNote: TabsOrder.GENERAL,
    vatCodeId: TabsOrder.GENERAL,
    priceAdjustmentType: TabsOrder.GENERAL,
    currencyCode: TabsOrder.GENERAL,
    percentage: TabsOrder.GENERAL,
    priceIncludesVat: TabsOrder.GENERAL,
    customers: TabsOrder.CUSTOMER,
    // products: TabsOrder.PRODUCTS,
    products: TabsOrder.GENERAL,
    cardSubscriptions: TabsOrder.POS,
    isDefaultPOSPriceList: TabsOrder.POS,
}
